<ui-table
  *ngIf="(state$ | async)?.selectedItems as selectedItems"
  [rowSelection]="'checkbox'"
  [fields]="fields"
  [pager]="pager$"
  [selected]="selectedItems"
  [pagination]="false"
  (select)="selectHandler($event)">
  <div tableActions>
    <app-entity-actions
      [config]="{ showAdd: false, showAddToCollection: false, showExport: false }"
      [selectedItemsCount]="selectedItems?.length"
      (delete)="deleteSelectedHandler(selectedItems)">
      <button
        append
        mat-raised-button
        matBadgePosition="before"
        matBadgeColor="accent"
        [disabled]="state?.selectedItems?.length === 0 && files?.length === 0"
        [matBadge]="state?.selectedItems?.length || files?.length"
        (click)="uploadHandler()">
        {{ 'Carica' | translate }}
      </button>
    </app-entity-actions>
  </div>
</ui-table>
